<template>
  <section class="layout">
    <n-header ref="nheader" :hideHeaderScroll="hideHeaderScroll"></n-header>
    <transition>
     <router-view></router-view>
    </transition>
    <n-footer></n-footer>
  </section>
</template>

<script>
export default {
  data() {
    return {
      hideHeaderScroll: false
    };
  },
  mounted () {

  },
  methods: {
    handleSearch(val){
  
    },
    //关闭顶部滚动效果
    handHideHeaderScroll(){
      console.log("handHideHeaderScroll-----")
      this.hideHeaderScroll = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.layout {
  width:100%;
  height:100%;
}
.enter-active {
  transition: all .3s ease;
}
.leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.enter, .leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
